import { render, staticRenderFns } from "./VoteGrade.vue?vue&type=template&id=466f0fe9&scoped=true"
import script from "./VoteGrade.vue?vue&type=script&lang=js"
export * from "./VoteGrade.vue?vue&type=script&lang=js"
import style0 from "./VoteGrade.vue?vue&type=style&index=0&id=466f0fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f0fe9",
  null
  
)

export default component.exports